import { getThemeAssetUrl } from './themeAssets';

const icons = [
  getThemeAssetUrl('svg/userPictures/user-picture-1.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-2.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-3.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-4.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-5.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-6.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-7.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-8.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-9.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-10.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-11.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-12.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-13.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-14.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-15.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-16.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-17.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-18.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-19.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-20.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-21.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-22.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-23.svg'),
  getThemeAssetUrl('svg/userPictures/user-picture-24.svg'),
];

export const getIconsList = () => icons;

export const getUserProfileImg = (index) => {
  if (index === -1) {
    return icons[icons.length - 1];
  }
  return icons[index];
};
